<template>
  <div class="developer-tab">
    <div class="content-section">
      <h2>Developer Information</h2>
      <div class="info-cards">
        <div class="info-card">
          <div class="info-icon developer">
            <span class="material-symbols-outlined">account_circle</span>
          </div>
          <div class="info-content">
            <div class="info-label">{{ $t("Developers.developerName") }}</div>
            <span
              class="info-value link"
              @click="showDeveloper"
              style="cursor: pointer"
            >
              {{ developer.developerName || "N/A" }}
            </span>
          </div>
        </div>

        <div class="info-card">
          <div class="info-icon email">
            <span class="material-symbols-outlined">mail</span>
          </div>
          <div class="info-content">
            <div class="info-label">{{ $t("Developers.supportEmail") }}</div>
            <template v-if="developer.appDeveloperSupportEmail">
              <a
                :href="'mailto:' + developer.appDeveloperSupportEmail"
                class="link info-value"
              >
                {{ developer.appDeveloperSupportEmail }}
              </a>
            </template>
            <template v-else>
              <div class="info-value">{{ "N/A" }}</div>
            </template>
          </div>
        </div>

        <div class="info-card">
          <div class="info-icon website">
            <span class="material-symbols-outlined">language</span>
          </div>
          <div class="info-content">
            <div class="info-label">{{ $t("Apps.visitSupportPage") }}</div>
            <template v-if="developer.appDeveloperSupportWebSite">
              <a
                :href="developer.appDeveloperSupportWebSite"
                target="_blank"
                rel="noopener"
                class="link info-value"
              >
                {{ $t("Apps.visitSupportPage") }} <span class="material-symbols-outlined" style="font-size: 16px;">open_in_new</span>
              </a>
            </template>
            <template v-else>
              <div class="info-value">{{ "N/A" }}</div>
            </template>
          </div>
        </div>

        <div class="info-card">
          <div class="info-icon store">
            <span class="material-symbols-outlined">store</span>
          </div>
          <div class="info-content">
            <div class="info-label">{{ $t("Developers.developerPage") }}</div>
            <span
              class="info-value link"
              @click="goToStore(developer.developerUrl)"
              style="cursor: pointer"
            >
              {{ $t("Developers.viewOnStore") }} <span class="material-symbols-outlined" style="font-size: 16px;">open_in_new</span>
            </span>
          </div>
        </div>

        <div class="info-card">
          <div class="info-icon location">
            <span class="material-symbols-outlined">location_on</span>
          </div>
          <div class="info-content">
            <div class="info-label">{{ $t("Developers.address") }}</div>
            <div class="info-value">
              {{ developer.appDeveloperSupportAddressText || "N/A" }} 
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeveloperTab",
  props: {
    developer: {
      type: Object,
      required: true,
    },
  },
  methods: {
    showDeveloper() {
      this.$router.push({
        name: "Developer",
        params: { storeId: this.developer.developerUrlId },
      })
    },
    goToStore(url) {
      window.open(url, "_blank");
    }
  },
};
</script>

<style scoped>
.developer-tab {
  max-width: 1200px;
  margin: 0 auto;
  padding: 4px;
}

.content-section {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

h2 {
  font-size: 20px;
  font-weight: 500;
  color: #202124;
  margin-bottom: 24px;
}

.info-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
}

.info-card {
  background: #f8f9fa;
  border-radius: 16px;
  padding: 20px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.info-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.info-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.info-icon .material-symbols-outlined {
  font-size: 24px;
}

.info-icon.developer {
  background: #e8f5e9;
  color: #4caf50;
}

.info-icon.email {
  background: #fff3e0;
  color: #ff9800;
}

.info-icon.website {
  background: #e1f5fe;
  color: #03a9f4;
}

.info-icon.store {
  background: #f3e5f5;
  color: #9c27b0;
}

.info-icon.location {
  background: #ffebee;
  color: #f44336;
}

.info-content {
  flex: 1;
  min-width: 0;
}

.info-label {
  font-size: 12px;
  color: #5f6368;
  margin-bottom: 4px;
}

.info-value {
  font-size: 14px;
  font-weight: 500;
  color: #202124;
  word-break: break-word;
}

.link {
  color: #1a73e8;
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}
</style>
